// built-from: /value-stream-mapping-workspace v1 impl:value-stream-mapping-workspace role:implementation
import { useCallback, useEffect, useRef, useState } from 'react';
import type { Area } from '../utils/scope';
import type { UseSessionReturn } from './sessionTypes';

export interface StreamAsset extends Area {
  mappingSessionId?: string;
  sequenceOverlay?: unknown;
  vsmBaseline?: unknown;
  sharedProcesses?: { version: number; processIds: string[] };
}
/** Read-only asset reads; unlike useSession this hook never allocates or binds a session. */
export function useStreamAssets(engagementId: string | null, sessionId?: string) {
  const [streams, setStreams] = useState<StreamAsset[]>([]);
  const [session, setSession] = useState<Pick<UseSessionReturn, 'sessionId' | 'newModel' | 'spine'> & Partial<Pick<UseSessionReturn, 'conversationHistory'>>>();
  const [error, setError] = useState<string | null>(null);
  const currentEngagement = useRef(engagementId); currentEngagement.current = engagementId;
  const refresh = useCallback(async () => {
    if (!engagementId) return;
    try {
      const response = await fetch(`/api/engagements/${encodeURIComponent(engagementId)}/streams`);
      if (!response.ok) throw new Error('Value streams could not be loaded.');
      const body = await response.json(); if (currentEngagement.current === engagementId) { setStreams(body.streams || []); setError(null); }
    } catch (failure) { if (currentEngagement.current === engagementId) setError((failure as Error).message); }
  }, [engagementId]);
  useEffect(() => { setStreams([]); void refresh(); }, [refresh]);
  useEffect(() => {
    let cancelled = false; setSession(undefined);
    if (sessionId) void (async () => {
      try {
        const response = await fetch(`/api/sessions/${encodeURIComponent(sessionId)}`);
        if (!response.ok) throw new Error('The original VSM session could not be read.');
        const body = await response.json();
        if (!cancelled) setSession({ sessionId, newModel: body.newModel || { flowText: '', openQuestions: '', nextQuestion: '', raw: '', frozenBoundary: 0 }, spine: body.spine || [], conversationHistory: body.conversationHistory || [] });
      } catch (failure) { if (!cancelled) setError((failure as Error).message); }
    })();
    return () => { cancelled = true; };
  }, [sessionId]);
  return { streams, session, error, refresh };
}
